/* eslint-disable react/jsx-handler-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import { withRouter } from "react-router-dom";
import Modal from "~/components/common/molecules/Modal";
import { MDBInput } from "mdbreact";
import { sendEmailInvoice } from "~/store/invoice/actions";
import isEmail from "validator/lib/isEmail";
import styles from "./style.module.scss";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";

const info = get(partnerInfo, "info");
const hospitalName = find(info, { key: "name" });

const ElectricInvoicesResultSearchPageMobile = Loadable({
  loader: () =>
    import(
      /* mobile */ "~/components/desktop/pages/ElectricInvoicesResultSearch"
    ),
  loading: LoadableLoading
});
const ElectricInvoicesResultSearchPageDesktop = Loadable({
  loader: () =>
    import(
      /* desktop */ "~/components/desktop/pages/ElectricInvoicesResultSearch"
    ),
  loading: LoadableLoading
});

class ElectricInvoicesResultSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalInputEmail: false,
      inputEmail: "",
      fileHoaDon: "",
      ID: 0
    };
  }

  methods = {
    handleSelectInvoice: url => {
      window.open(url);
    },
    handleGoBack: () => {
      const { history } = this.props;
      history.push("/tra-cuu-hoa-don-dien-tu");
    },
    handleInputEmail: (invoice, event) => {
      this.setState({
        fileHoaDon: invoice.FileHoaDon,
        ID: invoice.ID
      });
      this.onToggleModalInputEmail();
      event.stopPropagation();
    }
  };

  onToggleModalInputEmail = () => {
    this.setState({
      showModalInputEmail: !this.state.showModalInputEmail,
      errorMissEmail: "",
      inputEmail: ""
    });
  };

  handleChangeEmail = e => {
    const email = e.target.value;
    if (email === "") {
      this.setState({
        errorMissEmail: "Vui lòng nhập email.",
        inputEmail: email
      });
    } else if (!isEmail(email)) {
      this.setState({
        errorMissEmail: "Vui lòng nhập đúng định dạng email.",
        inputEmail: email
      });
    } else {
      this.setState({
        errorMissEmail: "",
        inputEmail: email
      });
    }
  };

  renderBodyModalInputEmail = () => {
    const { errorMissEmail } = this.state;
    return (
      <div>
        <MDBInput
          label="Nhập email để nhận thông tin hóa đơn"
          type="text"
          id="text"
          onChange={this.handleChangeEmail}
          value={this.state.inputEmail}
        />
        {errorMissEmail && (
          <span className={styles.alert}>{errorMissEmail}</span>
        )}
      </div>
    );
  };

  handleSendEmail = () => {
    const { inputEmail, ID, fileHoaDon } = this.state;
    const postData = {
      InvoiceID: ID,
      FileHoaDon: fileHoaDon,
      EmailAddress: inputEmail
    };
    this.props.sendEmailInvoice(postData);
    this.onToggleModalInputEmail();
  };

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <ElectricInvoicesResultSearchPageMobile
            {...this.props}
            {...this.methods}
          />
        ) : (
          <ElectricInvoicesResultSearchPageDesktop
            {...this.props}
            {...this.methods}
          />
        )}
        <Modal
          modal={this.state.showModalInputEmail}
          title="Thông báo"
          iconTitle={<i className="fal fa-bell" />}
          className="centered"
          centered
          onCancel={this.onToggleModalInputEmail}
          onOk={this.handleSendEmail}
          footer
          footerConfirm
          okText="Gửi email"
          cancelText="Quay lại"
          children={this.renderBodyModalInputEmail()}
          toggle={this.onToggleModalInputEmail}
          okDisabled={this.state.errorMissEmail !== ""}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    invoice: { invoices, loading }
  } = state;
  return {
    device: type,
    invoices,
    loading
  };
};

const ElectricInvoicesResultSearchHelmet = withTitle({
  component: ElectricInvoicesResultSearch,
  title: `${hospitalName.value} | Thông tin hóa đơn`
});

export default connect(mapStateToProps, { sendEmailInvoice })(
  withRouter(ElectricInvoicesResultSearchHelmet)
);
